import { AiOutlineInstagram } from 'react-icons/ai';
import { AiFillGithub } from 'react-icons/ai';
import { AiFillLinkedin } from 'react-icons/ai';
import { AiFillFacebook } from 'react-icons/ai';

export const links = [
  { id: 1, link: '#', title: 'Home' },
  { id: 2, link: '#about', title: 'About' },
  { id: 3, link: '#services', title: 'Services' },
  { id: 4, link: '#portfolio', title: 'Portfolio' },
  { id: 5, link: '#contact', title: 'Contact' }
];

export const socials = [
  {
    id: 1,
    link: 'https://www.instagram.com/lengynnn/',
    icon: <AiOutlineInstagram />
  },
  {
    id: 2,
    link: 'https://github.com/kainguyen104',
    icon: <AiFillGithub />
  },
  {
    id: 3,
    link: 'https://www.linkedin.com/in/kainguyen104/',
    icon: <AiFillLinkedin />
  },
  {
    id: 4,
    link: 'https://www.facebook.com/nguyendeptrai.dzai',
    icon: <AiFillFacebook />
  }
];
